import React from 'react';
const BADGES: Array<{
  label: string;
  className: string;
}> = [{
  label: 'VISA',
  className: 'bg-[#1A1F71] text-white tracking-[0.2em]'
}, {
  label: 'Mastercard',
  className: 'bg-[#EB001B] text-white'
}, {
  label: 'Mercado Pago',
  className: 'bg-[#009EE3] text-white'
}];
interface PaymentBadgesProps {
  className?: string;
}
export function PaymentBadges({
  className = ''
}: PaymentBadgesProps) {
  return <div className={`flex flex-wrap items-center justify-center gap-2 ${className}`} data-id="element-36" data-mp="3a6muichcw8up">
      {BADGES.map(badge => <span key={badge.label} className={`px-3 py-1.5 rounded-md text-[11px] font-bold uppercase ${badge.className}`} data-id="element-37" data-mp="365jdvnrhi8sf">
          {badge.label}
        </span>)}
    </div>;
}